import React from 'react'
import { Box, Typography } from '@mui/material'

import { INTERAX_COLORS } from '../../../constants/colors'

export interface SettingFieldRowProps {
  label: string
  description?: string
  control: React.ReactNode // right-side control (switch)
  htmlFor?: string // associates the label with the control for a11y
  disabled?: boolean
}

// Label + description on the left, control on the right. Stacks on xs, splits on sm+.
export const SettingFieldRow: React.FC<SettingFieldRowProps> = ({ label, description, control, htmlFor, disabled }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      alignItems: { xs: 'flex-start', sm: 'center' },
      justifyContent: 'space-between',
      gap: { xs: 1.5, sm: 2, md: 2 },
      py: { xs: 1.5, sm: 2 },
      opacity: disabled ? 0.5 : 1
    }}
  >
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography
        component="label"
        htmlFor={htmlFor}
        sx={{ display: 'block', fontSize: '16px', fontWeight: 500, color: INTERAX_COLORS.white }}
      >
        {label}
      </Typography>
      {description && (
        <Typography sx={{ mt: 0.5, fontSize: '13px', color: INTERAX_COLORS.thunderGrey }}>{description}</Typography>
      )}
    </Box>
    <Box sx={{ flexShrink: 0 }}>{control}</Box>
  </Box>
)
